import {navigateToPage} from '../../../../../../shared/scripts/ui_utils/ClientUtils.ts'
import {ViewPopupLanguage} from '../../../../../../shared/scripts/ui_popup/ViewPopupLanguage.ts'
import {clientIntl} from '../../../../../../shared/scripts/ClientI18n.ts'
import {StorageWrapper} from '../../../../../../shared/scripts/StorageWrapper.ts'
import {uiManager} from '../../../../EntryMobile.ts'
import {MorePageContainer} from '@colonist/ui-platform'
import {mountUIReactComponent} from '../../../../../../shared/scripts/ui_platform/mountUIReactComponent.tsx'

export class UIMMorePageController {
    constructor() {
        mountUIReactComponent('more-page-container', MorePageContainer).render({
            onNavigate: (path: string) => {
                navigateToPage(path, false, true)
            },
            onExternalNavigate: (url: string) => {
                navigateToPage(url, true)
            },
            onLanguageClick: () => {
                new ViewPopupLanguage()
            },
            onRulebookClick: () => {
                navigateToPage(`${clientIntl.getLanguagePathPrefix()}/catan-rules?style=mobile`, false, true)
                const currentScene = uiManager.sceneController.scene
                if(currentScene == undefined) return
                StorageWrapper.setLastScene(currentScene)
            },
        })
    }
}
